import { Controller } from "@hotwired/stimulus"


export default class extends Controller {

  static values = {
    amount: Number,
    stripePublicKey: String,
    clientSecret: String,
    returnUrl: String,
  }

  connect() {
    console.log(this.stripePublicKeyValue)
    this.stripe = Stripe(this.stripePublicKeyValue);
    this.loadStripeForm()
    this.checkStatus()
  }

  async loadStripeForm() {
    const appearance = {
      theme: 'stripe',
    };

    this.elements = this.stripe.elements({appearance, clientSecret: this.clientSecretValue});
    const paymentElementOptions = {
      layout: "tabs",
    };

    const paymentElement = this.elements.create("payment", paymentElementOptions);
    paymentElement.mount("#payment-element");

    this.element.querySelector('#credit-pack-change').classList.remove('d-none');
    this.element.querySelector('.submit').classList.remove('d-none');

  }

  async handleSubmit(e) {
    e.preventDefault();
    this.setLoading(true);

    const {error} = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: this.returnUrlValue,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      this.showMessage(error.message);
    } else {
      this.showMessage("An unexpected error occurred.");
    }

    this.setLoading(false);
  }

  async checkStatus() {
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    const {paymentIntent} = await this.stripe.retrievePaymentIntent(clientSecret);

    switch (paymentIntent.status) {
      case "succeeded":
        this.showMessage("Payment succeeded!");
        break;
      case "processing":
        this.showMessage("Your payment is processing.");
        break;
      case "requires_payment_method":
        this.showMessage("Your payment was not successful, please try again.");
        break;
      default:
        this.showMessage("Something went wrong.");
        break;
    }
  }

  showMessage(messageText) {
    const messageContainer = this.element.querySelector(".payment-message-container");
    const message = this.element.querySelector('.payment-message')

    messageContainer.classList.remove("d-none");
    message.textContent = messageText;

    setTimeout(function () {
      messageContainer.classList.add("d-none");
      message.textContent = "";
    }, 4000);
  }

  setLoading(isLoading) {
    if (isLoading) {
      // Disable the button and show a spinner
      document.querySelector(".submit").disabled = true;
      document.querySelector(".spinner-border").classList.remove("d-none");
    } else {
      document.querySelector(".submit").disabled = false;
      document.querySelector(".spinner-border").classList.add("d-none");
    }
  }
}
